import { object, string } from 'yup'
import { useTranslation } from 'react-i18next'

import { IItemTask } from './KritTasksListView'

export const useCreateTasksSchema = (): IItemTask => {
    const { t } = useTranslation()
    const schema = object().shape({
        name: string().required(t('validation.required')).default(null),
        description: string().required(t('validation.required')).default(null),
        deadline: string().required(t('validation.required')).default(null),
        user: string().required(t('validation.required')).default(null),
    })

    return { schema }
}
